import { getLoggedinUser } from "../api";

/**
 * Get user role from user profile
 * @param {Object} userProfile - Optional user profile object. If not provided, will get from localStorage
 * @returns {string} - User role ('admin' or 'seller')
 */
export const getUserRole = (userProfile = null) => {
  // If no userProfile provided, get from localStorage
  if (!userProfile) {
    userProfile = getLoggedinUser();
  }
  
  if (!userProfile) {
    return null;
  }
  
  // Check different possible locations for role
  if (userProfile.role) {
    return userProfile.role;
  }
  
  if (userProfile.data && userProfile.data.role) {
    return userProfile.data.role;
  }
  
  // Default to admin if no role found
  return "admin";
};

/**
 * Check if user is admin
 * @param {Object} userProfile - User profile object
 * @returns {boolean}
 */
export const isAdmin = (userProfile) => {
  return getUserRole(userProfile) === "admin";
};

/**
 * Check if user is seller
 * @param {Object} userProfile - User profile object
 * @returns {boolean}
 */
export const isSeller = (userProfile) => {
  return getUserRole(userProfile) === "seller";
};

